import {
  type ImageSize,
  canvasToArrayBufferResized,
  getCanvasFromVideoElement,
  isCanvasBlank,
} from '../image';
import { type Publisher } from './types';

export const getCurrentImageFromPublisher = async (
  publisher: Publisher,
  imageSize?: ImageSize,
): Promise<undefined | ArrayBuffer> => {
  const videoElement = publisher.videoElement?.();
  if (!videoElement) {
    return;
  }

  const canvas = getCanvasFromVideoElement(videoElement);

  const isBlank = isCanvasBlank(canvas);
  if (isBlank) {
    return;
  }

  return canvasToArrayBufferResized(canvas, imageSize);
};
